module.exports = __webpack_public_path__ + "e9058f5ff916421766a934a4ceb52957.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Princess@2x.png
// module id = 327
// module chunks = 0